const isEmpty = (obj) => Object.keys(obj).length === 0;

export default function formatBulkAppointmentErrors(responseData) {
  if (!Array.isArray(responseData)) {
    return responseData;
  }

  return responseData
    .map((err, idx) => {
      if (isEmpty(err)) {
        return null;
      }
      const labelled = {};
      Object.keys(err).forEach((key) => {
        const newKey = key === "non_field_errors" ? key : `${key} in line ${idx + 1}`;
        labelled[newKey] = err[key];
      });
      return labelled;
    })
    .filter(Boolean);
}
